(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  if (!customElements.get('meri-footer')) {
    customElements.define(
      'meri-footer',
      class extends HTMLElement {
        connectedCallback() {
          this.events?.abort();
          this.observer?.disconnect();
          const initialize = () => {
            if (!this.querySelector('.footer-bottom')) return false;
            this.observer?.disconnect();
            this.events = new AbortController();
            const signal = this.events.signal;
            const mobile = matchMedia('(max-width: 760px)');
            const disclosures = [...this.querySelectorAll('.footer-disclosure')];
            const sync = () => {
              for (const details of disclosures)
                details.open = !mobile.matches || Boolean(details.querySelector('[data-footer-feedback]'));
            };
            sync();
            mobile.addEventListener('change', sync, { signal });
            this.addEventListener(
              'shopify:block:select',
              (event) => {
                const details = event.target.closest('.footer-menu')?.querySelector('details');
                if (details) details.open = true;
              },
              { signal },
            );
            this.addEventListener(
              'focusin',
              (event) => {
                if (event.target.matches('summary')) return;
                const details = event.target.closest('details');
                if (details) details.open = true;
              },
              { signal },
            );
            return true;
          };
          if (!initialize()) {
            this.observer = new MutationObserver(initialize);
            this.observer.observe(this, { childList: true, subtree: true });
          }
        }
        disconnectedCallback() {
          this.events?.abort();
          this.observer?.disconnect();
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gift-card"]) return;
  try {
    
  if (!customElements.get('gift-card-details')) {
    customElements.define(
      'gift-card-details',
      class extends HTMLElement {
        connectedCallback() {
          this.abort?.abort();
          this.abort = new AbortController();
          const signal = this.abort.signal;
          const code = this.querySelector('[data-gift-code]');
          const status = this.querySelector('[data-gift-status]');
          const copy = this.querySelector('[data-gift-copy]');
          const print = this.querySelector('[data-gift-print]');
          copy?.addEventListener(
            'click',
            async () => {
              try {
                if (!navigator.clipboard?.writeText) throw new Error('clipboard-unavailable');
                await navigator.clipboard.writeText(code.value.replace(/\s/g, ''));
                if (this.isConnected) status.textContent = this.dataset.copied;
              } catch {
                code.focus();
                code.select();
                status.textContent = this.dataset.copyManual;
              }
            },
            { signal },
          );
          print?.addEventListener('click', () => window.print(), { signal });
          if (copy) copy.hidden = false;
          if (print) print.hidden = false;
          const qr = this.querySelector('[data-gift-qr]');
          if (!qr || this.qrBuilt) return;
          const unavailable = () => {
            if (this.isConnected && !this.qrBuilt) status.textContent = this.dataset.qrUnavailable;
          };
          const renderQr = () => {
            if (!this.isConnected || this.qrBuilt || !qr.dataset.qrValue || typeof window.QRCode !== 'function')
              return false;
            try {
              new window.QRCode(qr, { text: qr.dataset.qrValue, width: 128, height: 128 });
              qr.hidden = false;
              this.qrBuilt = true;
              clearTimeout(this.qrTimeout);
              return true;
            } catch {
              unavailable();
              return false;
            }
          };
          if (!renderQr()) {
            const library = document.querySelector('[data-meri-gift-qr-library]');
            library?.addEventListener('load', renderQr, { signal, once: true });
            library?.addEventListener('error', unavailable, { signal, once: true });
            this.qrTimeout = setTimeout(unavailable, 8000);
          }
        }
        disconnectedCallback() {
          this.abort?.abort();
          clearTimeout(this.qrTimeout);
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('meri-navigation')) {
    customElements.define(
      'meri-navigation',
      class extends HTMLElement {
        connectedCallback() {
          if (this.controller) return;
          if (!this.querySelector('.site-menu nav') && document.readyState === 'loading') {
            this.ready?.abort();
            this.ready = new AbortController();
            document.addEventListener(
              'DOMContentLoaded',
              () => {
                if (this.isConnected) this.connectedCallback();
              },
              { once: true, signal: this.ready.signal },
            );
            return;
          }
          try {
            this.initialize();
          } catch (error) {
            this.disconnectedCallback();
            throw error;
          }
        }
        initialize() {
          if (this.controller) return;
          const menu = this.querySelector('.site-menu');
          const nav = menu?.querySelector('nav');
          if (!nav) return;
          this.ready?.abort();
          this.ready = null;
          this.controller = new AbortController();
          const signal = this.controller.signal;
          const desktop = matchMedia('(min-width: 761px)');
          // A dropdown panel is fixed under its summary, inside the viewport, so a scrolling row never clips it.
          const place = (dropdown) => {
            const box = dropdown.querySelector('summary').getBoundingClientRect();
            const panel = dropdown.querySelector('div');
            const width = panel.getBoundingClientRect().width;
            panel.style.setProperty(
              '--menu-left',
              `${Math.max(16, Math.min(box.left, document.documentElement.clientWidth - width - 16))}px`,
            );
            panel.style.setProperty('--menu-top', `${box.bottom}px`);
          };
          const positionMenu = (event) => {
            const dropdown = event.target;
            if (!desktop.matches || !dropdown.matches('.nav-dropdown') || !dropdown.open) return;
            place(dropdown);
          };
          this.addEventListener('toggle', positionMenu, { signal, capture: true });
          const closeSubmenus = () => {
            for (const expanded of menu.querySelectorAll('details[open]')) expanded.open = false;
          };
          nav.addEventListener('scroll', closeSubmenus, { signal, passive: true });
          window.addEventListener('resize', closeSubmenus, { signal, passive: true });
          // Scrolling only closes desktop dropdowns, so listen to the page scroll
          // while one is open instead of for the whole page lifetime.
          const closeOnScroll = () => {
            if (desktop.matches) closeSubmenus();
          };
          const syncScrollWatch = () => {
            if (desktop.matches && menu.querySelector('.nav-dropdown[open]'))
              window.addEventListener('scroll', closeOnScroll, { signal, passive: true });
            else window.removeEventListener('scroll', closeOnScroll);
          };
          this.addEventListener('toggle', syncScrollWatch, { signal, capture: true });
          const sync = () => {
            menu.dataset.desktop = String(desktop.matches);
            menu.open = desktop.matches;
          };
          desktop.addEventListener('change', sync, { signal });
          desktop.addEventListener('change', syncScrollWatch, { signal });
          this.addEventListener(
            'keydown',
            (event) => {
              if (event.key !== 'Escape') return;
              const expanded = event.target.closest('details[open]');
              if (!expanded || (expanded === menu && desktop.matches)) return;
              expanded.open = false;
              expanded.querySelector('summary').focus();
              event.preventDefault();
            },
            { signal },
          );
          // Tabbing past a desktop dropdown closes it, so an open panel never covers the next control.
          // A click elsewhere has no focus target and is handled by the document click below.
          this.addEventListener(
            'focusout',
            (event) => {
              const expanded = event.target.closest('.nav-dropdown[open]');
              if (desktop.matches && expanded && event.relatedTarget && !expanded.contains(event.relatedTarget))
                expanded.open = false;
            },
            { signal },
          );
          document.addEventListener(
            'click',
            (event) => {
              if (this.contains(event.target)) return;
              for (const expanded of menu.querySelectorAll('details[open]')) expanded.open = false;
              if (!desktop.matches) menu.open = false;
            },
            { signal },
          );
          // 2.8.5 (Owner): the phone's quick links row shows the menu's first level. A link with a submenu opens it
          // under the row as the desktop menu does; scrolling the row or the page, a click elsewhere, Escape or
          // tabbing past it closes it, and only one is open at a time.
          const quick = this.closest('header')?.querySelector('.header-quick-links');
          if (quick) {
            const closeQuick = () => {
              for (const expanded of quick.querySelectorAll('.quick-dropdown[open]')) expanded.open = false;
            };
            quick.addEventListener(
              'toggle',
              (event) => {
                const dropdown = event.target;
                if (!dropdown.matches('.quick-dropdown')) return;
                if (dropdown.open) {
                  for (const other of quick.querySelectorAll('.quick-dropdown[open]'))
                    if (other !== dropdown) other.open = false;
                  place(dropdown);
                }
                if (quick.querySelector('.quick-dropdown[open]'))
                  window.addEventListener('scroll', closeQuick, { signal, passive: true });
                else window.removeEventListener('scroll', closeQuick);
              },
              { signal, capture: true },
            );
            quick.addEventListener('scroll', closeQuick, { signal, passive: true });
            window.addEventListener('resize', closeQuick, { signal, passive: true });
            quick.addEventListener(
              'keydown',
              (event) => {
                const expanded = event.key === 'Escape' && event.target.closest('.quick-dropdown[open]');
                if (!expanded) return;
                expanded.open = false;
                expanded.querySelector('summary').focus();
                event.preventDefault();
              },
              { signal },
            );
            quick.addEventListener(
              'focusout',
              (event) => {
                const expanded = event.target.closest('.quick-dropdown[open]');
                if (expanded && event.relatedTarget && !expanded.contains(event.relatedTarget)) expanded.open = false;
              },
              { signal },
            );
            // Safari sends no click for a tap on plain page content, so a touch anywhere else closes it.
            document.addEventListener(
              'pointerdown',
              (event) => {
                if (!quick.contains(event.target)) closeQuick();
              },
              { signal, passive: true },
            );
          }
          sync();
        }
        disconnectedCallback() {
          this.ready?.abort();
          this.ready = null;
          this.controller?.abort();
          this.controller = null;
        }
      },
    );
  }
  // A menu row never shows a scrollbar; these arrows show on the side that still has links and scroll most of
  // a row. The first state appears without a fade. Swipe, trackpad and keyboard focus keep working.
  if (!customElements.get('meri-scroll-arrows')) {
    customElements.define(
      'meri-scroll-arrows',
      class extends HTMLElement {
        connectedCallback() {
          const row = document.getElementById(this.getAttribute('target'));
          if (!row || this.controller) return;
          this.controller = new AbortController();
          const { signal } = this.controller;
          const update = () => {
            const room = row.scrollWidth - row.clientWidth;
            // Right-to-left rows count scrollLeft down from 0. Safari reports positions past either end while a
            // swipe bounces there; that bounce must not light the arrow for the far side (2.8.5, Owner).
            const travelled = getComputedStyle(row).direction === 'rtl' ? -row.scrollLeft : row.scrollLeft;
            const offset = Math.min(room, Math.max(0, travelled));
            const start = room > 1 && offset > 1;
            const end = room > 1 && offset < room - 1;
            this.toggleAttribute('data-start', start);
            this.toggleAttribute('data-end', end);
            row.toggleAttribute('data-scroll-start', start);
            row.toggleAttribute('data-scroll-end', end);
          };
          row.setAttribute('data-scroll-arrows', '');
          row.addEventListener('scroll', update, { signal, passive: true });
          this.addEventListener(
            'click',
            (event) => {
              const arrow = event.target.closest('[data-direction]');
              if (!arrow) return;
              const forward = (arrow.dataset.direction === 'end') === (getComputedStyle(row).direction !== 'rtl');
              row.scrollBy({
                left: row.clientWidth * 0.7 * (forward ? 1 : -1),
                behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
              });
            },
            { signal },
          );
          this.observer = new ResizeObserver(update);
          this.observer.observe(row);
          for (const link of row.children) this.observer.observe(link);
          document.fonts?.ready.then(() => {
            if (this.controller) update();
          });
          update();
          requestAnimationFrame(() => {
            if (this.controller) this.setAttribute('data-ready', '');
          });
        }
        disconnectedCallback() {
          this.controller?.abort();
          this.controller = null;
          this.observer?.disconnect();
          this.observer = null;
          this.removeAttribute('data-ready');
          const row = document.getElementById(this.getAttribute('target'));
          row?.removeAttribute('data-scroll-arrows');
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
